import { CHANGE_DEVICE } from '../actions/general';

const initState = {
  device: 'mobile',
};

export default (state = {}, action) => {
  const newState = { ...initState, ...state };
  switch (action.type) {
    case CHANGE_DEVICE:
      return { ...newState, device: action.device };
    default:
      return newState;
  }
};
